import React from 'react';
import { Helmet } from 'react-helmet-async';
import ReactGA from 'react-ga4';
import CommonHeader from '../Components/Headers/CommonHeader';
import Nav from '../Components/FAQ/Nav';
import FAQContent from '../Components/FAQ/FAQContent';
import Footer from '../Components/Home/Footer';
import $ from 'jquery';

export default function AboutFaq() {
  $('.popover').hide();
  ReactGA.send({ hitType: 'pageview', page: '/FAQ', title: 'FAQ' });

  return (
    <React.Fragment>
      <Helmet>
        <title>DISGENET: Frequently Asked Questions</title>
        <meta name="description" content="Find answers to frequently asked questions about DISGENET." />
      </Helmet>
      <CommonHeader />
      <FAQContent />
      <Footer />
    </React.Fragment>
  );
}
